<template>
    <div>
        <div class="d-flex align-items-center text-align justify-content-center" 
            style="height: 300px; flex-direction: column"
            v-if="loadingInitial">
            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <br>
            <p class="mt-2">Loading</p>
        </div>

        <form @submit.prevent="submitForm()" class="row" v-else>
            <div class="col-12 col-md-6" v-for="(item, index) in 10" :key="index">
                <div class="form-group">
                    <label for="">Custom Field {{index+1}}</label>
                    <input type="text" v-model="formOptional[`optional_value_${index+1}`]" class="form-control">
                </div>
            </div>

            <button class="btn btn-success waves-effect waves-light mt-4" :disabled="loading">
                Simpan
                <div class="spinner-border text-light ml-2" role="status" v-if="loading">
                    <span class="sr-only">Loading...</span>
                </div>
            </button>
        </form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            loadingInitial: true,
            companyID: '',
            editPass: false,
            formOptional: {
                optional_value_1: '',
                optional_value_2: '',
                optional_value_3: '',
                optional_value_4: '',
                optional_value_5: '',
                optional_value_6: '',
                optional_value_7: '',
                optional_value_8: '',
                optional_value_9: '',
                optional_value_10: '',
            },
            dataInstance: {
                address: '',
                logo: null,
                fileLogo: '',
                company_code: '',
                va_prefix: '',
                name: '',
                name_user: '',
                username: '',
                password: null,
                old_password: null
            }
        }
    },
    methods: {
        changeImage(event){
            this.dataInstance.fileLogo = event.target.files[0]
            this.dataInstance.logo = URL.createObjectURL(event.target.files[0])
        },
        async loadInitialData() {
            this.loadingInitial = true;
    
            // GET COMPANY SETTING
            const companySetting = await this.$http.get(`${this.API_URL}company-setting`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            })

            const companyForm = await this.$http.get(`${this.API_URL}company/${companySetting.data.data.company_id}`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            })

            this.companyID = companySetting.data.data.company_id

            this.dataInstance = {
                address: companyForm.data.data.address,
                logo: companyForm.data.data.logo,
                fileLogo: '',
                va_prefix: companyForm.data.data.va_prefix,
                company_code: companyForm.data.data.company_code,
                name: companyForm.data.data.name,
                is_transaction: companyForm.data.data.is_transaction,
                is_billing: companyForm.data.data.is_billing,
                is_sim: companyForm.data.data.is_sim,
                is_use_approval: companyForm.data.data.is_use_approval
            }

            for (let index = 1; index <= 10; index++) {
                console.log(index);
                this.formOptional['optional_value_'+index] = companySetting.data.data['optional_value_'+index]
            }

            this.loadingInitial = false;
        },
        async submitForm() {
            this.loading = true

            let form = new FormData()
            // form.append('name', this.dataInstance.name);
            // form.append('address', this.dataInstance.address);
            // form.append('va_prefix', this.dataInstance.va_prefix);
            // form.append('company_code', this.dataInstance.company_code);
            // form.append('is_transaction', this.dataInstance.is_transaction);
            // form.append('is_billing', this.dataInstance.is_billing);
            // form.append('is_sim', this.dataInstance.is_sim);
            // form.append('is_use_approval', this.dataInstance.is_use_approval);
            // for (let index = 1; index <= 10; index++) {
            //     form.append('optional_value_'+index, this.formOptional['optional_value_'+index])
            // }
            // form.append('_method', 'PUT');
            
            this.$http.put(`${this.API_URL}company-setting`, this.formOptional, {
                headers: { 
                    'Authorization': `Bearer ${this.$cookies.get("token_instance")}`,
                }
            })
            .then(response => {
                const result = response.data;
                
                if(result.success) {
                    this.sAlert('success', "Berhasil mengupdate profile!")
                    // this.loadInitialData()
                }else {
                    this.sAlert('error', result.message)
                }
                this.loading = false;
            })
            .catch(error => {
                this.loading = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            });
        }
    },
    mounted() {
        this.loadInitialData()
    }
}
</script>

<style>

</style>